import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bdfe46a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "card-global space-y-8 pagination-scroll-target",
  "data-pagination-scroll-anchor": "desktop"
}
const _hoisted_2 = { class: "flex items-start justify-between gap-4 mb-4" }
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "flex flex-wrap justify-end gap-3" }
const _hoisted_5 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_6 = { class: "col-span-8 md:col-span-8 sm:col-span-3" }
const _hoisted_7 = {
  for: "company-id",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_8 = {
  key: 0,
  class: "col-span-4 md:col-span-4 sm:col-span-3"
}
const _hoisted_9 = {
  for: "company-id",
  class: "block text-sm font-medium text-gray-700"
}
const _hoisted_10 = { value: null }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "col-span-6 md:col-span-3 sm:col-span-3" }
const _hoisted_13 = { class: "block text-sm" }
const _hoisted_14 = { value: null }
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "col-span-6 md:col-span-4 sm:col-span-3" }
const _hoisted_17 = { class: "block text-sm" }
const _hoisted_18 = { class: "col-span-6 md:col-span-5 sm:col-span-3" }
const _hoisted_19 = { class: "block text-sm" }
const _hoisted_20 = { class: "flex space-x-8" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = { class: "grid grid-cols-12 gap-6" }
const _hoisted_23 = { class: "col-span-6 md:col-span-3 sm:col-span-3" }
const _hoisted_24 = { class: "block text-sm" }
const _hoisted_25 = { class: "col-span-6 md:col-span-3 sm:col-span-3" }
const _hoisted_26 = { class: "block text-sm" }
const _hoisted_27 = {
  class: "mt-5 pagination-scroll-target",
  "data-pagination-scroll-anchor": "mobile"
}
const _hoisted_28 = {
  class: "text-gray-800",
  "aria-live": "polite"
}
const _hoisted_29 = {
  key: 0,
  class: "mb-2 inline-flex cursor-pointer items-center gap-2 text-sm text-gray-700"
}
const _hoisted_30 = ["checked", "onChange"]
const _hoisted_31 = {
  key: 0,
  role: "alert",
  class: "text-red-600"
}
const _hoisted_32 = {
  key: 1,
  class: "flex flex-row-reverse"
}

import {
  computed,
  nextTick,
  onBeforeUnmount,
  onMounted,
  ref,
  watch,
} from "vue";
import DocumentListItem from "./DocumentListItem.vue";
import DocumentDataService from "@/services/documents/document/DocumentDataService";
import { onBeforeRouteLeave, useRoute } from "vue-router";
import { useStore } from "vuex";
import { DocumentActions } from "@/store/modules/document/actions";
import { DocumentGetters } from "@/store/modules/document/getters";
import router from "@/router";
import {
  getDocumentStatusFilterOptions,
  getDocumentStatusLabel,
} from "@/utils/labels";
import { RouteGetters } from "@/store/modules/route";
import { AuthGetters } from "@/store/modules/auth";
import { SearchIcon } from "@heroicons/vue/outline";
import { t } from "@/i18n";
import Multiselect from "@vueform/multiselect";
import TablePagination from "@/components/common/pagination/TablePagination.vue";
import { formatFoundDocuments } from "@/utils/documentCount";
import { accountKey } from "@/utils/accountSession";
import {
  captureListScroll,
  readListReturnState,
  saveListReturnState,
} from "@/utils/listReturnState";

type DocumentListSnapshot = {
  filter: Record<string, unknown>;
  creator: { id: string; fullName: string } | null;
  extended: boolean;
};

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const store = useStore();
const documentStatusOptions = computed(() => getDocumentStatusFilterOptions());

const routeName = computed(() => {
  const status = route.query.status;
  const value = Array.isArray(status) ? status[0] : status;
  if (["SUCCESS", "PROCESS", "DENIED"].includes(String(value))) {
    return getDocumentStatusLabel(String(value));
  }
  return store.getters[RouteGetters.GET_ROUTE_NAME];
});
const currentUser = computed(
  () => store.getters[AuthGetters.GET_USER_IDENTITY]
);
const canBulkCreate = computed(() => {
  const permissions = Array.isArray(currentUser.value?.permissions)
    ? currentUser.value.permissions
    : [];
  return permissions.includes("DOCUMENT_BATCH_CREATE");
});

const extendedFilters = ref(false);
const hasLoaded = ref(false);
const listError = ref("");
const listLoading = ref(false);
const restoring = ref(true);
let listSequence = 0;
let active = true;
const currentAccount = () =>
  accountKey(store.getters[AuthGetters.GET_USER_IDENTITY]);
const selectedDraftIds = ref<string[]>([]);

const canSelectDraft = (document: any) =>
  ["NEW", "REWORK"].includes(document.status) &&
  document?.creatorInfo?.userInfo?.id === currentUser.value?.id;

const toggleDraft = (id: string) => {
  selectedDraftIds.value = selectedDraftIds.value.includes(id)
    ? selectedDraftIds.value.filter((item) => item !== id)
    : [...selectedDraftIds.value, id];
};

const openDraftBatchEdit = () =>
  router.push({
    name: "DocumentDraftBatchEdit",
    query: { ids: selectedDraftIds.value.join(",") },
  });

const dataProvider = computed(
  () => store.getters[DocumentGetters.GET_DATA_PROVIDER]
);
const documents = computed(() => {
  return hasLoaded.value ? dataProvider.value?.items || [] : [];
});
const pager = computed(() => {
  return (
    dataProvider.value?.pager || {
      currentPage: 1,
      totalPages: 1,
      startPage: 1,
      endPage: 1,
    }
  );
});

const types = ref();
const constructors = ref([]);
const creatorId = ref<string | null>(null);
const creatorOptions = ref<any[]>([]);
const currentType = computed(() => {
  const type = route.query.type;
  return Array.isArray(type) ? type[0] ?? "ALL" : type ?? "ALL";
});

const documentRangeLabel = computed(() => {
  const totalItems = pager.value.totalItems;
  const pageSize = pager.value.pageSize;

  if (typeof totalItems !== "number" || typeof pageSize !== "number") {
    return formatFoundDocuments(documents.value.length);
  }

  if (totalItems === 0 || documents.value.length === 0) {
    return t("documentList.noDocuments");
  }

  const from = (pager.value.currentPage - 1) * pageSize + 1;
  const to = Math.min(from + documents.value.length - 1, totalItems);

  return t("documentList.shownRange")
    .replace("{from}", String(from))
    .replace("{to}", String(to))
    .replace("{total}", String(totalItems));
});
const currentStatus = computed(() => {
  const status = route.query.status;
  const value = Array.isArray(status) ? status[0] : status;
  return ["SUCCESS", "PROCESS", "DENIED"].includes(String(value))
    ? String(value)
    : null;
});
const emptyFilter = () => ({
  title: null,
  type: currentType.value,
  status: currentStatus.value,
  constructorId: null,
  regNumber: null,
  creatorFullName: null,
  createdAtStart: null,
  createdAtEnd: null,
});
const filter = ref<any>(emptyFilter());
function restoreFilters() {
  const saved = readListReturnState<DocumentListSnapshot>(
    currentAccount(),
    route.fullPath
  );
  filter.value = saved ? { ...saved.filters.filter } : emptyFilter();
  creatorId.value = saved?.filters.creator?.id || null;
  creatorOptions.value = saved?.filters.creator ? [saved.filters.creator] : [];
  extendedFilters.value = saved?.filters.extended || false;
  return saved;
}
let restoredState = restoreFilters();
const formatDateFilter = (value: string | null, endOfDay = false) => {
  if (!value) {
    return null;
  }

  const [year, month, day] = value.split("-");
  return `${endOfDay ? "23:59:59" : "00:00:00"} ${day}-${month}-${year}`;
};

const buildCreatorOptionsFromDocuments = (items: Array<any>, query = "") => {
  const normalizedQuery = query.trim().toLowerCase();
  const unique = new Map<string, { id: string; fullName: string }>();

  items.forEach((item) => {
    const user = item?.creatorInfo?.userInfo;
    if (!user?.id || !user?.fullName) {
      return;
    }
    if (
      normalizedQuery &&
      !String(user.fullName).toLowerCase().includes(normalizedQuery)
    ) {
      return;
    }
    unique.set(user.id, {
      id: user.id,
      fullName: user.fullName,
    });
  });

  return Array.from(unique.values()).sort((left, right) =>
    left.fullName.localeCompare(right.fullName)
  );
};

const selectedCreatorName = () => {
  const selectedId = creatorId.value;
  if (!selectedId) {
    return null;
  }

  const selected = creatorOptions.value.find(
    (item: any) => item.id === selectedId
  );
  return selected?.fullName || null;
};

const loadCreators = async (query = "") => {
  const account = currentAccount(),
    path = route.fullPath;
  const current = () =>
    active && account === currentAccount() && path === route.fullPath;
  const selected = creatorOptions.value.find(
    (item) => item.id === creatorId.value
  );
  try {
    const response = await DocumentDataService.getCreatorFilter({
      page: 0,
      fullName: query || undefined,
    });
    if (!current()) return;
    creatorOptions.value = response.data.data.items || [];
  } catch (error) {
    if (!current()) return;
    const response = await DocumentDataService.getAll({
      type: currentType.value,
      page: 1,
    });
    if (!current()) return;
    creatorOptions.value = buildCreatorOptionsFromDocuments(
      response.data?.data?.items || [],
      query
    );
  }
  if (selected && !creatorOptions.value.some((item) => item.id === selected.id))
    creatorOptions.value.push(selected);
};

const resetFilters = async () => {
  filter.value = emptyFilter();
  creatorId.value = null;
  extendedFilters.value = false;
  await loadCreators();
  await updateFilter();
};

const buildFilterPayload = (page = 1) => ({
  ...filter.value,
  page,
  creatorFullName: selectedCreatorName(),
  createdAtStart: formatDateFilter(filter.value.createdAtStart),
  createdAtEnd: formatDateFilter(filter.value.createdAtEnd, true),
});

const updateFilter = async () => {
  selectedDraftIds.value = [];
  await loadPage(1);
};

const getPage = async (page: number) => {
  selectedDraftIds.value = [];
  await loadPage(page);
};

async function loadPage(page: number, scrollY?: number) {
  const sequence = ++listSequence;
  listLoading.value = true;
  const account = currentAccount(),
    path = route.fullPath;
  const params = buildFilterPayload(page);
  const creator = creatorOptions.value.find(
    (item) => item.id === creatorId.value
  );
  const snapshot: DocumentListSnapshot = {
    filter: { ...filter.value },
    creator: creator ? { id: creator.id, fullName: creator.fullName } : null,
    extended: extendedFilters.value,
  };
  listError.value = "";
  const current = () =>
    active &&
    sequence === listSequence &&
    account === currentAccount() &&
    path === route.fullPath;
  try {
    let result = await store.dispatch(
      DocumentActions.FETCH_DATA_PROVIDER,
      params
    );
    if (!current() || !result) return;
    const lastPage = Math.max(1, result.pager.totalPages);
    if (page > lastPage) {
      result = await store.dispatch(DocumentActions.FETCH_DATA_PROVIDER, {
        ...params,
        page: lastPage,
      });
      if (!current() || !result) return;
    }
    hasLoaded.value = true;
    saveListReturnState(
      account,
      path,
      result.pager.currentPage,
      snapshot,
      scrollY
    );
    await nextTick();
    if (current() && scrollY !== undefined)
      window.scrollTo({ top: scrollY, behavior: "auto" });
  } catch {
    if (current()) listError.value = t("documentList.loadError");
  } finally {
    if (current()) {
      restoring.value = false;
      listLoading.value = false;
    }
  }
}

onBeforeRouteLeave(() => captureListScroll(currentAccount(), route.fullPath));
onBeforeUnmount(() => {
  active = false;
  listSequence++;
});

async function initializeList() {
  const account = currentAccount(),
    path = route.fullPath;
  await loadPage(restoredState?.page || 1, restoredState?.scrollY);
  if (!active || account !== currentAccount() || path !== route.fullPath)
    return;

  try {
    const constructorResponse =
      await DocumentDataService.getConstructorFilter();
    if (!active || account !== currentAccount() || path !== route.fullPath)
      return;
    constructors.value = constructorResponse.data.data.items;
    await loadCreators();
  } catch {
    if (active && account === currentAccount() && path === route.fullPath)
      listError.value = t("documentList.loadError");
  }
}
onMounted(initializeList);
watch(
  currentAccount,
  () => {
    listSequence++;
    hasLoaded.value = false;
    constructors.value = [];
    selectedDraftIds.value = [];
    restoring.value = true;
    restoredState = restoreFilters();
    if (currentAccount()) void initializeList();
  },
  { flush: "sync" }
);

watch(
  () => [route.query.type, route.query.status],
  async () => {
    selectedDraftIds.value = [];
    hasLoaded.value = false;
    restoring.value = true;
    restoredState = restoreFilters();
    await loadPage(restoredState?.page || 1, restoredState?.scrollY);
  }
);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_TextButton = _resolveComponent("TextButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_unref(routeName) || _unref(t)("documentList.myDocuments")), 1),
        _createElementVNode("div", _hoisted_4, [
          (selectedDraftIds.value.length)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                type: "button",
                variant: "default",
                class: "px-6",
                onClick: openDraftBatchEdit
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("documentDraftBatch.open")) + " (" + _toDisplayString(selectedDraftIds.value.length) + ") ", 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(canBulkCreate))
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                type: "button",
                variant: "default",
                class: "px-6",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'DocumentBatchCreate' })))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)("documentBatch.open")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_Button, {
            type: "button",
            class: "px-8",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push({ name: 'DocumentCreate' })))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("layout.createDocument")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("label", _hoisted_7, _toDisplayString(_unref(t)("processUsersList.searchByDocName")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "search",
            class: "w-full flex-none w-2/5 rounded-lg border-gray-300",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filter.value.title) = $event))
          }, null, 512), [
            [_vModelText, filter.value.title]
          ])
        ]),
        (_unref(route).query.type === 'ALL')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, _toDisplayString(_unref(t)("documentList.documentStatus")), 1),
              _withDirectives(_createElementVNode("select", {
                id: "company-id",
                name: "company-id",
                class: "block w-full flex-1 rounded-lg border-gray-300",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.status) = $event))
              }, [
                _createElementVNode("option", _hoisted_10, _toDisplayString(_unref(t)("common.allStatuses")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(documentStatusOptions), (status, index) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: index,
                    key: index
                  }, _toDisplayString(status), 9, _hoisted_11))
                }), 128))
              ], 512), [
                [_vModelSelect, filter.value.status]
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("label", _hoisted_13, _toDisplayString(_unref(t)("processUsersList.documentCategory")), 1),
          _withDirectives(_createElementVNode("select", {
            name: "templates",
            id: "templates",
            class: "block w-full rounded-lg border-gray-300",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filter.value.constructorId) = $event))
          }, [
            _createElementVNode("option", _hoisted_14, _toDisplayString(_unref(t)("common.allCategories")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(constructors.value, (constructor) => {
              return (_openBlock(), _createElementBlock("option", {
                key: constructor.id,
                value: constructor.id
              }, _toDisplayString(constructor.name), 9, _hoisted_15))
            }), 128))
          ], 512), [
            [_vModelSelect, filter.value.constructorId]
          ])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("label", _hoisted_17, _toDisplayString(_unref(t)("processUsersList.documentNumber")), 1),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "block w-full rounded-lg border-gray-300",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filter.value.regNumber) = $event))
          }, null, 512), [
            [_vModelText, filter.value.regNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(t)("processUsersList.documentCreator")), 1),
          _createVNode(_unref(Multiselect), {
            modelValue: creatorId.value,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((creatorId).value = $event)),
            options: creatorOptions.value,
            mode: "single",
            searchable: true,
            "close-on-select": true,
            "value-prop": "id",
            "track-by": "fullName",
            label: "fullName",
            placeholder: _unref(t)('processUsersList.documentCreator'),
            onSearchChange: loadCreators,
            onOpen: _cache[7] || (_cache[7] = ($event: any) => (loadCreators()))
          }, null, 8, ["modelValue", "options", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createVNode(_component_Button, {
          onClick: _cache[8] || (_cache[8] = ($event: any) => (updateFilter())),
          class: "btn-search"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SearchIcon), { class: "button-icon mr-2" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)("common.search")), 1)
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          type: "button",
          class: "px-4 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50",
          onClick: resetFilters
        }, _toDisplayString(_unref(t)("common.clear")), 1),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_TextButton, {
            onClick: _cache[9] || (_cache[9] = ($event: any) => (extendedFilters.value = !extendedFilters.value))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("processUsersList.extendedFilters")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["space-y-8 overflow-hidden transition-all duration-500", { 'max-h-0': !extendedFilters.value, 'max-h-screen': extendedFilters.value }])
      }, [
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(t)("reports.createdAtStart")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "block w-full rounded-lg border-gray-300",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filter.value.createdAtStart) = $event))
            }, null, 512), [
              [_vModelText, filter.value.createdAtStart]
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("label", _hoisted_26, _toDisplayString(_unref(t)("reports.createdAtEnd")), 1),
            _withDirectives(_createElementVNode("input", {
              type: "date",
              class: "block w-full rounded-lg border-gray-300",
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((filter.value.createdAtEnd) = $event))
            }, null, 512), [
              [_vModelText, filter.value.createdAtEnd]
            ])
          ])
        ])
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(documentRangeLabel)), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(documents), (document) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "space-y-4 py-4",
        key: document.id
      }, [
        (canSelectDraft(document))
          ? (_openBlock(), _createElementBlock("label", _hoisted_29, [
              _createElementVNode("input", {
                type: "checkbox",
                checked: selectedDraftIds.value.includes(document.id),
                onChange: ($event: any) => (toggleDraft(document.id))
              }, null, 40, _hoisted_30),
              _createTextVNode(" " + _toDisplayString(_unref(t)("documentDraftBatch.select")), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(DocumentListItem, {
          id: document.id,
          title: document.documentInfo.title,
          attachedFilesCount: 3,
          registrationId: document.documentInfo.regNumber,
          creationDate: document.createdAt,
          creatorName: document.creatorInfo.userInfo.fullName,
          categoryName: document.constructorInfo.name,
          processes: [],
          status: document.status,
          favorite: document.favorite
        }, null, 8, ["id", "title", "registrationId", "creationDate", "creatorName", "categoryName", "status", "favorite"])
      ]))
    }), 128)),
    (listError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(listError.value), 1))
      : _createCommentVNode("", true),
    (hasLoaded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createVNode(TablePagination, {
            current: _unref(pager).currentPage,
            "total-pages": _unref(pager).totalPages,
            "start-page": _unref(pager).startPage,
            "end-page": _unref(pager).endPage,
            "scroll-on-page-change": !restoring.value,
            loading: listLoading.value,
            onPageChanged: getPage
          }, null, 8, ["current", "total-pages", "start-page", "end-page", "scroll-on-page-change", "loading"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})